import { FC } from "react";
import { newsServiceFactory } from "../../../services/NewsServiceImpl";
import { useTranslation } from "react-i18next";
import { INews, NewsFiltersValues } from "../../../domain/models/News";
import { NewsFiltersFields, newsFiltersSchemaFactory } from "../../../validation-schemas/NewsSchemas";
import { GenericEntityPage } from "../../shared/GenericEntityPage";
import NewsCard from "./NewsCard";
import { NEWS_CLIENT_URL } from "../../../Config";
import NewsEditor from "./NewsEditor";

const newsService = newsServiceFactory();
const NewsPage: FC = () => {
    const { t } = useTranslation();

    return (
        <GenericEntityPage<INews, NewsFiltersValues>
            filtersFieldsMeta={NewsFiltersFields}
            filtersSchema={newsFiltersSchemaFactory(t)}
            service={newsService}
            renderItem={(item, onEdit, onDelete) => (
                <NewsCard
                    item={item}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onClick={() => window.open(`${NEWS_CLIENT_URL}/${item.id}`, "_blank")}
                />
            )}
            renderEditor={({ entity, onClose, onSave, translateFields }) => (
                <NewsEditor entity={entity} onClose={onClose} onSave={onSave} translateFields={translateFields} />
            )}
        />
    );
};

export default NewsPage;
